import { render, staticRenderFns } from "./IncomingCallModal.vue?vue&type=template&id=b3e0ac30&scoped=true"
import script from "./IncomingCallModal.vue?vue&type=script&lang=js"
export * from "./IncomingCallModal.vue?vue&type=script&lang=js"
import style0 from "./IncomingCallModal.vue?vue&type=style&index=0&id=b3e0ac30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e0ac30",
  null
  
)

export default component.exports